import { Brand } from '../hooks/useSelectBrand';

export interface ARSource {
  src: string;
  srcIos: string;
}

export interface ContentItemActionStep {
  title: string;
  titleKey: string;
  description: string;
  descriptionKey: string;
  ar: ARSource;
}

export enum ContentItemActionType {
  Make = 'make',
  Cut = 'cut',
}

export interface ContentItemAction {
  title: string;
  type: ContentItemActionType;
  finalTitle: string;
  finalTitleKey: string;
  steps: ContentItemActionStep[];
}

export interface ContentItem {
  id: string;
  title: string;
  titleKey: string;
  description: string;
  descriptionKey: string;
  imageUrl: string;
  tags: string[];
  actions: ContentItemAction[];
}

export interface APIContentRequest {
  tags?: string[] | null;
  brand: Brand;
}

export interface APIContentResponse {
  content: ContentItem[];
}
